import api from "./Api";

class FechamentoVendasCupomService {
  GetFechamentoVendasCupom(payload) {
    return api.get("/v1/fechamentoVendasCupom/" + payload).then((response) => {
      return response.data;
    });
  }

  PostFechamentoVendasCupom(payload) {
    return api.post("/v1/fechamentoVendasCupom/", payload).then((response) => {
      return response.data;
    });
  }

  PutFechamentoVendasCupom(payload) {
    return api.put("/v1/fechamentoVendasCupom/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteFechamentoVendasCupom(payload) {
    return api
      .delete("/v1/fechamentoVendasCupom/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetFechamentoVendasCupomOData(payload) {
    return api
      .get("/OData/FechamentoVendasCupom" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirSuprimentoSangria(payload) {
    return api
      .post("/v1/FechamentoVendasCupom/ImprimirSuprimentoSangria/", payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }
}

export default new FechamentoVendasCupomService();
